module.exports = __webpack_public_path__ + "media/images/svgs/cross_sign-85362db637cb6a242993122e83a820e5.svg";